import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'Beranda', path: '/login-dashboard', icon: 'Home' },
    { label: 'Profil Perusahaan', path: '/company-profile-form', icon: 'Building2' },
    { label: 'Penilaian', path: '/supplier-management', icon: 'ClipboardList' },
    { label: 'Analisis AI', path: '/ai-analysis-dashboard', icon: 'Brain' },
    { label: 'Laporan', path: '/executive-report', icon: 'FileText' },
  ];

  const isActive = (path) => {
    if (path === '/supplier-management') {
      return [
        '/supplier-management',
        '/operational-assessment',
        '/equipment-analysis',
        '/financial-analysis-form',
        '/market-assessment',
        '/governance-evaluation'
      ]?.includes(location?.pathname);
    }
    return location?.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="header-container">
        <div className="header-content">
          <Link to="/login-dashboard" className="header-logo">
            <div className="header-logo-icon">
              <Icon name="Milk" size={28} color="var(--color-primary)" />
            </div>
            <span className="header-logo-text">I_SUKA DueDiligence</span>
          </Link>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <div className="flex items-center gap-2">
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </div>
              </Link>
            ))}
          </nav>

          <button
            onClick={toggleMobileMenu}
            className="header-mobile-toggle"
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </header>
      <div className={`header-mobile-menu ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <nav className="header-mobile-nav">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`header-mobile-nav-item ${isActive(item?.path) ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="flex items-center gap-3">
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </div>
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Header;